import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import { Subject, takeUntil, tap } from 'rxjs';
import { AnalyticsService } from 'src/app/shared/services/analytics.service';
import { ProviderModel } from '../../core/models/provider.model';
import { ProvidersService } from '../../core/services/providers.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly destroy$ = new Subject<void>();
  private readonly callBackUrlRouteParamName = 'callback';

  providerInfo?: ProviderModel | null = null;

  constructor(
    private readonly analyticsService: AnalyticsService,
    private readonly providerService: ProvidersService,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const callBack = this.activatedRoute.snapshot.queryParamMap.get(this.callBackUrlRouteParamName);

    this.providerService.getProvider("greenscope").pipe(
      tap(result => {
        if (result){
          this.providerInfo = {
            name : result?.name,
            webAppUri: result?.webAppUri,
            callBackUri: callBack
          }
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  ngAfterViewInit(): void {
    this.analyticsService.trackEventNavigateHomePage();
  }
}
